export function getFormattedSeconds(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const formattedMinutes = minutes.toString().padStart(1, '0');
  const formattedSeconds = remainingSeconds.toFixed(0).padStart(2, '0');

  return `${formattedMinutes}:${formattedSeconds}`;
}
